<script>
import { BIcon } from 'bootstrap-vue'

import { services } from '@src/utils/common-services'

export default {
  components: {
    BIcon,
  },
  props: {
    menu: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      //   menubar: false,
      profile: {},
      classToggle: true,
      menuToggle: false,
      minimizeFooter: false,
      img: null,
      windowWidths: window.screen.width,
      appRightToggle: false,
      applicationListToggle: false,
      user: null,
    }
  },
  watch: {
    classToggle(oldVal, newVal) {
      if (oldVal !== newVal) {
        this.appRightToggle = this.classToggle
      }
    },
    menuToggle(oldVal, newVal) {
      if (oldVal !== newVal) {
        this.applicationListToggle = this.menuToggle
      }
    },
  },

  beforeMount() {
    this.getUser()
    if (this.windowWidths < 767) {
      this.classToggle = false
    }
    /*   const menuStatus = false
   // console.log(this.$store.state.jv.auth)
this.user=services.decodeJWT(services.getAuth())
    this.profile = services.getCandidatesNameIcon(this.user)
    if (this.windowWidths < 767) {
      this.menubar = menuStatus === null ? false : menuStatus
    }
    this.img = null // this.currentUser.avatar */
  },
  beforeDestroy() {
    this.$root.$off('changeMenu')
    this.$root.$off('open')
    var doc = this.$refs.layout
    if (doc !== undefined) doc.innerHTML = ''
  },
  mounted() {
    //   console.log(this.menubar)
    this.$root.$on('changeMenu', (data) => {
      this.menubar = data.data
      this.checkDevice()
    })
    this.$root.$on('open', (data) => {
      this.classToggle = data
    })
    // this.profile = services.getCandidatesNameIcon(this.user)
  },
  methods: {
    getUser() {
      if (services.getAuth() !== null) {
        this.user = services.decodeJWT(services.getAuth())
        this.profile = services.getCandidatesNameIcon(this.user)

        var profileDetails = services.decodeJWT(services.getAuth())

        if (profileDetails.profile_id === null)
          profileDetails['profile_id'] = services.getLocalStorage('profile')
        if (profileDetails.profile_id !== null)
          this.$store
            .dispatch('jv/get', [
              'profile',
              {
                url: '/accounts/profile/' + profileDetails.profile_id,
                headers: services.getHeaderAuthorization(),
              },
            ])
            .then((token) => {
              this.img = token.avatar
            })
            .then((error) => {
              if (error) {
              }
            })
        else {
        }
      }
    },
    logout() {
      this.$router.push(
        this.$route.query.redirectFrom || { name: 'userlogout' }
      )
    },
    checkDevice() {
      if (this.windowWidths < 767) {
        this.classToggle = !this.classToggle
      }
    },
    changeMenuBar() {
      this.menubar = !this.menubar
      //    this.setMenubar({ newVal: this.menubar })
    },
  },
}
</script>

<template>
  <div ref="layout" :class="$style.appWraper">
    <div>
      <header>
        <div :class="$style.headerWraper" class="hidden-sm">
          <div :class="$style.headerLeft">
            <a
              href="javascript:void(0)"
              :class="
                classToggle
                  ? [$style.menuHamberger, $style.open]
                  : [$style.menuHamberger, $style.close]
              "
              @click="classToggle = !classToggle"
            >
              <BIcon :class="$style.miniMenu" icon="grid3x2-gap-fill"></BIcon>
              <BIcon :class="$style.maxMenu" icon="grid3x3-gap-fill"></BIcon>
            </a>
            <img src="@assets/images/logoD.png" alt="Logo" />
          </div>
          <div :class="$style.headerRight">
            <a
              href="javascript:void(0)"
              :class="$style.headerProfile"
              class="mr20"
            >
              <span :class="$style.avatar" class="FL">
                <img v-if="img !== null" :src="img" alt="avatar" />
                <span v-else>{{ profile.profileIcon }}</span>
                <!--  <BIcon icon="person-fill"></BIcon> -->
              </span>
              <h4 class="FL mt5"
                >{{ profile.fullName }}<span>{{ profile.email }}</span></h4
              >
              <div class="clear"></div>
            </a>
            <!-- <a href="#" :class="$style.notificationBar">
              <BIcon :class="$style.bellIcon" icon="bell-fill"></BIcon>
            </a> -->
          </div>
        </div>
      </header>
      <!-- Left side -->
      <div
        id="appLeft"
        :class="
          classToggle
            ? [$style.appLeft, $style.open]
            : [$style.appLeft, $style.close]
        "
        data-status="close"
      >
        <div :class="[$style.menuProfile, $style.moreSettings]">
          <div :class="$style.radialProgress" class="position-relative">
            <a href="javascript:void(0)" :class="$style.profileImage">
              <img
                v-show="img !== null"
                id="img"
                alt="Profile Image"
                :src="img"
              />
              <span v-show="img === null" :class="$style.shortName">{{
                profile.profileIcon
              }}</span>
            </a>
            <h3 :class="$style.profileName">{{ profile.fullName }}</h3>
            <p :class="$style.profileEmail"> {{ profile.email }} </p>
          </div>
        </div>
        <CommonBaseNavBar
          v-if="menu !== null"
          :menubar="classToggle"
          :menu="menu"
        />
      </div>
      <!-- Left side -->
      <section :class="$style.bodyWraper">
        <div
          :class="
            classToggle
              ? [$style.appRight, $style.short]
              : [$style.appRight, $style.long]
          "
        >
          <slot />
        </div>
      </section>
    </div>
  </div>
</template>
<style lang="scss" module>
@import '@design';

// .appWraper {
//   height: 100vh;
//   overflow-y: scroll;
//   scrollbar-width: thin;
// }

// Left Side menu starts here

// Left Side menu starts here
.appLeft {
  position: fixed;
  top: 55px;
  left: -1px;
  z-index: 99;
  min-height: 100vh;
  background: $color-left-menu;
  border: 1px solid #eee;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.03);
  transition: all ease-in-out 0.3s;

  li {
    position: relative;
    display: block;
    width: 100%;
    transition: all ease-in-out 0.3s;

    &:last-child {
      border-bottom: 0;
    }

    h3 {
      position: relative;
      display: inline-flex;
      width: 100%;
      padding: 15px 15px 15px 20px;
      margin: 0 !important;
      font-family: 'RobotoMedium', Helvetica Neue, sans-serif, Apple Color Emoji;
      font-size: 14px;
      line-height: 27px;
      color: #627282;
      text-decoration: none !important;
      border-bottom: 1px solid #f9f9f9 !important;
      transition: all ease-in-out 0.3s;
    }
    a {
      text-decoration: none !important;
    }

    svg {
      position: relative;
      top: 0;
      display: block;
      width: 27px;
      height: 27px;
      padding: 6px;
      font-size: 17px !important;
      line-height: 43px;
      color: #627282;
      background: #eee;
      border-radius: 5px;
      transition: all ease-in-out 0.3s;
    }

    &:hover,
    &.active {
      background: #fff3ee !important;
      transition: all ease-in-out 0.3s;
    }

    &:hover h3,
    &.active h3 {
      color: #e9510e;
      background: #fff3ee !important;
      transition: all ease-in-out 0.3s;

      svg {
        color: #e9510e !important;
        background: #ffd5c3;
        border-radius: 50px;
        transition: all ease-in-out 0.3s;
      }
    }

    .menuIcon {
      position: relative;
    }
  }

  &.close {
    width: 69px;
    li {
      background: #fff;
      // svg {
      //   margin: 0 auto;
      //   font-size: 11px;
      //   color: #627282;
      //   transition: all ease-in-out 0.3s;
      // }

      &:hover,
      &.active {
        // background: $color-left-menu-hover;
        background: #fff3ee !important;
        transition: all ease-in-out 0.3s;
        svg {
          margin: 0 auto;
          color: #e9510e !important;
          transition: all ease-in-out 0.3s;
        }
      }
      h3 {
        padding: 15px 20px;
        font-size: 0;
        color: transparent;
        text-align: center;

        &::before {
          position: absolute;
          top: 9px;
          left: 0;
          z-index: -1;
          width: 0;
          height: 34px;
          font-size: 11px;
          line-height: 34px;
          color: transparent;
          text-align: center;
          content: attr(data-menu);
          background: #e9510e;
          border-radius: 5px;
          border-radius: 4px;
          transition: all ease-in-out 0.3s;
        }

        &:hover::before {
          top: 9px;
          left: 80px;
          width: max-content;
          height: 34px;
          padding: 0 10px;
          color: #fff;
          transition: all ease-in-out 0.3s;
        }

        &::after {
          position: absolute;
          top: 18px;
          left: -20px;
          z-index: -2;
          width: 15px;
          height: 15px;
          content: '';
          background: #e9510e;
          border-radius: 1px;
          transition: all ease-in-out 0.3s;
          transform: rotate(45deg);
        }
        &:hover::after {
          top: 18px;
          left: 76px;
          width: 15px;
          height: 15px;
          transition: all ease-in-out 0.3s;
        }
      }
    }
  }

  .subMenu {
    .menuIcon {
      padding: 7px 10px 7px 30px;
      font-family: 'RobotoRegular', Helvetica Neue, sans-serif,
        Apple Color Emoji;
      font-size: 12px;
      border-bottom: 1px solid #fffaf8;

      .subMenuIcon {
        top: 0 !important;
        font-size: 12px !important;
      }
    }
    &:hover {
      background: #fff6f3 !important;
    }
  }

  &.open {
    width: 200px;
  }
}
// Left Side menu ends here

// Header
.headerWraper {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1001;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #eee;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.03);
}

.headerLeft {
  position: relative;
  float: left;
  width: 200px;
  padding: 10px 20px;

  img {
    float: right;
    width: 50px;
    margin-top: 4px;
  }

  .menuHamberger {
    display: block;
    float: left;
    margin: 8px 0;
    font-size: 18px;
    // color: $color-left-menu;
    color: #627282;

    &.open {
      .maxMenu {
        display: block;
      }
      .miniMenu {
        display: none;
      }
    }

    &.close {
      .maxMenu {
        display: none;
      }
      .miniMenu {
        display: block;
      }
    }
  }

  &::after {
    position: absolute;
    top: 15px;
    right: 0;
    width: 2px;
    height: 25px;
    content: '';
    background: #f8f9f9;
  }
}

.headerRight {
  float: left;
  width: calc(100% - 200px);
  padding: 10px 15px;

  .notificationBar {
    position: relative;
    display: block;
    float: right;
    width: 34px;
    height: 34px;
    padding: 7px;
    margin-right: 20px;
    color: #5f6768;
    background: #e3e4e5;
    border-radius: 50px;

    .bellIcon {
      font-size: 20px;
    }
  }

  .headerProfile {
    float: right;

    h4 {
      margin-top: 2px;
      margin-bottom: 0;
      font-family: 'RobotoMedium', Helvetica Neue, sans-serif, Apple Color Emoji;
      font-size: 12px;
      // color: $color-left-menu;
      line-height: 15px;
      color: #7d7d7d;
      span,
      a {
        display: block;
        font-family: 'RobotoRegular', Helvetica Neue, sans-serif,
          Apple Color Emoji;
        font-size: 11px;
        // color: $color-left-menu;
        color: #7d7d7d !important;
        text-decoration: none;
      }
    }
  }

  .avatar {
    position: relative;
    display: block;
    float: right;
    width: 34px;
    height: 34px;
    margin-right: 5px;
    overflow: hidden;
    font-family: 'RobotoRegular', Helvetica Neue, sans-serif, Apple Color Emoji;
    font-size: 11px;
    line-height: 30px;
    color: #7d7d7d;
    text-align: center;
    background: #fafafa;
    border: 2px solid #aab2bd;
    border-radius: 50px;

    &::after {
      position: absolute;
      top: -3px;
      left: -3px;
      display: block;
      width: 36px;
      height: 36px;
      content: '';
      border: 1px solid #fafafa;
      border-radius: 50px;
    }

    img {
      display: block;
      width: 100%;
      height: 100%;
      border-radius: 50px;
      object-fit: cover;
    }
  }
}
// Header

.bodyWraper {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background: $color-body-background;
}

// Right side block starts here
.appRight {
  width: 100%;
  padding-top: 55px;
  transition: all ease-in-out 0.3s;

  &.short {
    padding-left: 200px;
    transition: all ease-in-out 0.3s;
  }

  &.long {
    padding-left: 67px;
    transition: all ease-in-out 0.3s;
  }

  .mainWraper {
    width: 100%;
    min-height: calc(100vh - 55px);
    padding: 15px;
  }

  .innerWraper {
    position: relative;
    display: flex;
    min-height: calc(100vh - 85px);
    overflow: hidden;
    background: $color-body-inner-background;
    border: 1px solid #eee;
    border-radius: 10px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.03);
  }

  .progressMenuLeft {
    float: left;
    width: 30%;
  }

  .contentMenuRight {
    width: 100%;
  }
}
// Right Side block ends here

.form {
  max-width: 400px;
}
.disabledInput {
  input {
    background: #eeefef;
  }
}

.menuProfile {
  display: none;
}

@media (max-width: 991px) {
  .appRight {
    &.short {
      padding-left: 155px;
    }
  }

  .appLeft {
    li {
      h3 {
        font-size: 13px;
      }
    }

    &.open {
      width: 155px;
    }

    &.close {
      width: 69px;
    }
  }

  .form {
    max-width: 310px;
  }

  .mainWraper {
    padding: 0 !important;
  }

  // Profile
  // .menuProfile {
  //   padding: 20px 20px !important;

  //   .radialProgress {
  //     svg {
  //       transform: scale(0.8);
  //     }
  //   }
  // }

  .profileImage {
    transform: scale(0.8);
  }

  .profileName {
    margin: 0 0 !important;
    font-size: 15px !important;
  }

  .profileEmail {
    margin-bottom: 5px !important;
    font-size: 11px !important;
  }
  // profile

  .profileMenuLink {
    font-size: 12px !important;
    line-height: 14px !important;
  }
}

@media (max-width: 767px) {
  .headerWraper {
    display: none;
  }

  .progress {
    width: 80% !important;
    margin: 10px auto;
  }

  .appRight {
    padding: 0;
    &.short {
      padding-left: 0;
    }

    &.long {
      padding-left: 0;
    }

    ul > a {
      text-align: center;
    }
  }

  .appLeft {
    top: 0;
    z-index: 9;
    height: 100vh;
    overflow-y: scroll;
    border: none;

    &.close {
      left: -100%;
      width: 100%;
    }

    &.open {
      left: 0;
      width: 100%;
    }

    ul div {
      text-align: left;
    }
  }

  // MenuProfile starts here

  .menuProfile {
    display: block;
    padding: 40px 20px !important;
    color: #677071;
    text-align: center;
    cursor: pointer;

    &.moreSettings {
      padding: 40px 20px !important;
      background: #ff601c;
    }

    .profileImage {
      position: relative;
      display: block;
      width: 68px;
      height: 68px;
      margin: 0 auto;
      overflow: hidden;
      text-decoration: none !important;
      background: #5f6768;
      border: 2px solid #fff;
      border-radius: 50px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      &::after {
        position: absolute;
        top: 1px;
        left: 1px;
        width: 80px;
        height: 80px;
        content: '';
        background: transparent;
        // border: 2px solid $color-left-menu;
        border-radius: 50px;
      }
    }

    .shortName {
      font-family: 'RobotoMedium', Helvetica Neue, sans-serif, Apple Color Emoji;
      font-size: 19px;
      line-height: 65px;
      color: #fff !important;
      text-align: center;
    }

    .profileName {
      margin: 5px 0;
      font-family: 'RobotoMedium', Helvetica Neue, sans-serif, Apple Color Emoji;
      font-size: 18px !important;
      color: #fff;
    }

    .profileEmail {
      margin-bottom: 10px;
      font-family: 'RobotoRegular', Helvetica Neue, sans-serif,
        Apple Color Emoji;
      font-size: 14px !important;
      color: #fff;
    }
  }
  // MenuProfile ends here

  // Profile
  // .menuProfile {
  //   display: block;
  //   padding: 20px 20px !important;

  //   .radialProgress {
  //     svg {
  //       transform: scale(1);
  //     }
  //   }
  // }

  // .profileImage {
  //   transform: scale(1);
  // }

  // .profileName {
  //   margin: 5px 0 0 !important;
  //   font-size: 19px !important;
  // }

  // .profileEmail {
  //   margin-bottom: 5px !important;
  //   font-size: 14px !important;
  // }
  // profile

  .innerWraper {
    display: block !important;
  }
}

// @media (max-width: 575px) {
//   .menuProfile {

//   }
// }
</style>
